module.exports = __webpack_public_path__ + "img/ma.a3dd98bd.svg";